import Axios from "../config/axios-v1-config";

// Callers decide success by the truthiness of `.error`. axios hands over
// `data: ''` for an empty-body 4xx/5xx and `??` keeps that empty string, which
// made a failure read as success: `||` guarantees a truthy error object.
const toFaqError = (err) => ({
  error: err.response?.data || { message: null, status: err.response?.status ?? null },
});

export const getActiveFaqs = async () => {
  const faqs = await Axios.get("faqs/get-active-faqs").catch(toFaqError);

  return faqs;
};

export const getAllFaqs = async () => {
  const faqs = await Axios.get("faqs/get-all-faqs").catch(toFaqError);

  return faqs;
};

export const changeFaqStatus = async ({ id, status }) => {
  const faqs = await Axios.put(`faqs/status-faq/${id}`, { status }).catch(toFaqError);

  return faqs;
};

export const editFaq = async ({ values }) => {
  // console.log(values);
  const editedFaq = await Axios.put(`faqs/edit-faq/${values.id}`, { ...values }).catch(toFaqError);

  return editedFaq;
};

export const createFaq = async ({ values }) => {
  const faqs = await Axios.post("faqs/create-faq", { ...values }).catch(toFaqError);

  return faqs;
};

export const deleteFaqApi = async ({ id }) => {
  const faq = await Axios.delete(`faqs/delete-faq/${id}`).catch(toFaqError);

  return faq;
};
